import { Tabs } from '@base-ui-components/react/tabs'
import { Button, type ButtonProps } from '../primitives/button.js'
import { Close } from '@tunasong/icons'
import type { FC, Ref } from 'react'
import { IconButton } from '../primitives/index.js'
import styles from './content-group-tab.module.css'

interface CustomTabProps extends Omit<ButtonProps, 'onChange'> {
  label: string
  value: string
  ref?: Ref<HTMLButtonElement>
  onClose: (value: string) => void
}

const CustomGroupTab: FC<CustomTabProps> = ({ onClose, label = 'Untitled', value, ref, ...restProps }) => (
  <Button
    ref={ref}
    className={styles.tabButton}
    {...restProps}
  >
    {label}
    <IconButton
      onClick={ev => {
        ev.stopPropagation()
        onClose?.(value)
      }}
      className={styles.closeButton}
    >
      <Close size={12} />
    </IconButton>
  </Button>
)

const GroupTab = ({ value, ...props }: CustomTabProps) => (
  <Tabs.Tab value={value} render={<CustomGroupTab value={value} {...props} />} />
)

export const ContentGroupTab: FC<CustomTabProps> = GroupTab
